import type { LocationType, MapLocation } from '@/entities/dashboard/mapping';

export interface LocationDisplay {
  id: string;
  name: string;
  fullName: string;
  type: LocationType;
  typeName: string;
  coordinates: [number, number];
  icon: string;
  color: string;
}

export interface LocationWithStock extends MapLocation {
  stockValue?: number;
}

export interface LocationStatistics {
  totalLocations: number;
  warehouseCount: number;
  portCount: number;
  customerCount: number;
  siteCount: number;
  byRegion: Record<string, number>;
  byCountry: Record<string, number>;
}

export const LocationAddressFilterType = {
  CUSTOMER_ADDRESS: 'CUSTOMER_ADDRESS',
  ARRIVAL_PORT_TRANSSHIPMENT: 'ARRIVAL_PORT_TRANSSHIPMENT',
  ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE: 'ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE',
  WAREHOUSE_PICKUP: 'WAREHOUSE_PICKUP',
  STORAGE: 'STORAGE'
} as const;

export type LocationAddressFilterType = (typeof LocationAddressFilterType)[keyof typeof LocationAddressFilterType];

export interface LocationAddressOption {
  id: string; // Composite location id: {locationSiteId}~{locationId}
  name: string;
  addressLine: string | null;
  city: string | null;
  country: string | null;
}

export interface LocationAddressesParams {
  projectId: number;
  siteId: number;
  type: LocationAddressFilterType;
  search?: string;
}

export type LocationAddressesResponse = LocationAddressOption[];
